const ecosiaUser = require('./ecosia-user');

module.exports = {
  ecosiaUser
};
